import React, { useState, useEffect } from 'react';
import '../pages/Chatbot.scss' // Import the CSS file for the chatbot'
import options from '../data/doc.json';
import { LdsAccordion, LdsButton, LdsIcon, LdsVideoPlayer, LdsTabPanel, useLdsModal } from '@elilillyco/ux-lds-react'
import Accordion from '../components/Accordion';
import ServiceNowGuidanceModal from '../components/ServiceNowGuidanceModal';
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function Chatbot(props) {
  const location = useLocation();
  const fromPage = props?.fromPage;
  const { name } = useSelector(({ user }) => user);
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const handleMainAccordionClick = (id) => {
    setOpenAccordionId(id === openAccordionId ? null : id);
  };
  const [video, setVideo] = useState(false)

 const [data, setData] = useState(options); // Always show all documentation

  const [isChatbotOpen, setChatbotOpen] = useState(false);
  
  // ServiceNow guidance modal state
  const { isModalOpen: isServiceNowModalOpen, setIsModalOpen: setIsServiceNowModalOpen } = useLdsModal();

  const toggleChatbot = () => {
    setChatbotOpen(!isChatbotOpen);
  };

  const openServiceNowGuidance = () => {
    setIsServiceNowModalOpen(true);
  };

  const playVideo = (link) => {
    window.open(link)
    setVideo(true)
  }

  const viewDoc = (link) => {
    window.open(link)
    setVideo(true)
  }

  return (
    <>
      {video && <div className='player'>
      </div>}
      {/* Chatbot Initiate Button */}
      {!isChatbotOpen ? (
        <div className="chatbot-init-button">
          <div className="chatbot-init-open" onClick={toggleChatbot}>
            <LdsIcon name="ChatsFill" inline />
          </div>
        </div>
      ) : (
        <div className='chatbot-init-button'>
          <div className='chatbot-init-close' onClick={toggleChatbot}>
            <LdsIcon name="X" inline />
          </div>
        </div>
      )}

      {/* Chatbot Layout */}
      {isChatbotOpen && (

        <div className="chatbot-layout">
          <div className="chatbot-header">
            {/* <img style={{width:"50px"}} src={logo} className="logo-image" /> */}
            <h4 style={{padding:"5px" , marginBottom:"-5px", fontWeight:"bold"}}>Assist Hub</h4>

          </div>
          <div className="chatbot-messages">
            {Object.keys(data).map((key) => {
              let subOptions = data[key]?.features || {};
              return (
                <Accordion
                  key={key}
                  id={key}
                  title={key}
                  isOpen={key === openAccordionId}
                  onToggle={() => handleMainAccordionClick(key)}accordion-header
                >
                  <div>
                    {data[key]?.description}
                    <br></br>
                    <span className="button-container">
                    {<LdsButton onClick={() => viewDoc(data[key]?.doc)} className='document' name='files' icon='Files' classes='outlined' iconPosition='before' label="View Documentation">Documentation</LdsButton>}
                    {<LdsButton onClick={() => playVideo(data[key]?.link)} className='video' name='video' icon='PlayFill' classes='outlined' iconPosition='before' label="Play Video Guide">Video Guide</LdsButton>}
                    </span>
                    {Object.keys(subOptions).map((subKey) => (
                      <Accordion
                        key={subKey}
                        id={subKey}
                        title={subKey}
                        isOpen={subOptions[subKey]?.isOpen || false}
                        onToggle={() => {
                          // Toggle the subaccordion's open state
                          subOptions[subKey].isOpen = !subOptions[subKey]?.isOpen;
                          setData({ ...data, [key]: { ...data[key], features: { ...subOptions } } });
                        }}
                      >
                       {subOptions[subKey]?.description}&nbsp;<br /> 
                       {subOptions[subKey]?.link && <LdsButton className='video' onClick={() => playVideo(subOptions[subKey].link)}>Play Demo</LdsButton>} 
                      </Accordion>
                    ))}
                  </div>
                </Accordion>
              );
            })}
          </div>

          <div className="chatbot-buttons">
            <LdsButton onClick={openServiceNowGuidance}>Service Now Incident</LdsButton>
          </div>

        </div>
      )}
      
      {/* ServiceNow Guidance Modal */}
      <ServiceNowGuidanceModal 
        isModalOpen={isServiceNowModalOpen}
        setIsModalOpen={setIsServiceNowModalOpen}
      />
    </>
  );
}

export default Chatbot;
